module.exports = __webpack_public_path__ + "img/dictionary_icon_on.db32cd08.svg";